The pagination metadata for this page of position openings.
